export const programCategoryOptions = [
  { id: 'Foundation', name: 'Foundation' },
  { id: 'Attributes', name: 'Attributes' },
  { id: 'Application', name: 'Application' },
  { id: 'MemberResources', name: 'Member Resources' },
  { id: 'Supplemental', name: 'Supplemental' },
  { id: 'Course', name: 'Course' },
  { id: 'Legacy', name: 'Legacy' },
];
